// DI   HVAC-014
// Progressive enhancement for video controls

document.addEventListener('DOMContentLoaded', () => {
  const videoBanners = document.querySelectorAll('.hp-video-banner');
  
  videoBanners.forEach((banner) => {
    const videoContainer = banner.querySelector('.hp-video-banner__video-container');
    const video = banner.querySelector('.hp-video-banner__video');
    const playButton = banner.querySelector('.hp-video-banner__play-button');
    
    if (!video) return;

    // Handle HTML5 video elements (Shopify hosted)
    if (video.tagName === 'VIDEO') {
      // Force load video metadata on iOS to show first frame
      if (!video.hasAttribute('autoplay')) {
        video.load();
      }
      
      // Handle play button click for non-autoplay videos
      if (playButton && videoContainer) {
        playButton.addEventListener('click', () => {
          const shouldMute = videoContainer.dataset.muted === 'true';
          const shouldLoop = videoContainer.dataset.loop === 'true';
          const shouldShowControls = videoContainer.dataset.controls === 'true';
          const videoFit = videoContainer.dataset.fit;
          
          // Apply settings
          video.muted = shouldMute;
          video.loop = shouldLoop;
          if (shouldShowControls) {
            video.controls = true;
          }
          
          // Switch from cover (thumbnail mode) to the selected fit mode
          videoContainer.classList.remove('hp-video-banner__video-container--cover');
          videoContainer.classList.add(`hp-video-banner__video-container--${videoFit}`);
          
          // Play video and hide play button
          video.play().then(() => {
            videoContainer.classList.add('hp-video-banner__video-container--playing');
          }).catch((error) => {
            console.log('Video play prevented:', error);
          });
        });
        
        // Show play button again when video ends (if not looping)
        video.addEventListener('ended', () => {
          if (!video.loop) {
            const videoFit = videoContainer.dataset.fit;
            videoContainer.classList.remove('hp-video-banner__video-container--playing');
            videoContainer.classList.remove(`hp-video-banner__video-container--${videoFit}`);
            videoContainer.classList.add('hp-video-banner__video-container--cover');
          }
        });
      }
      
      // Ensure video plays on mobile devices when autoplay is enabled
      if (video.hasAttribute('autoplay')) {
        video.play().then(() => {
          if (videoContainer) {
            videoContainer.classList.add('hp-video-banner__video-container--playing');
          }
        }).catch((error) => {
          console.log('Video autoplay prevented:', error);
        });
      }

      video.addEventListener('play', () => {
        if (videoContainer) {
          videoContainer.classList.add('hp-video-banner__video-container--playing');
        }
      });

      // Handle video loading errors
      video.addEventListener('error', (e) => {
        console.error('Video loading error:', e);
      });

      // Optional: Pause video when not in viewport (performance optimization)
      if ('IntersectionObserver' in window && video.hasAttribute('autoplay')) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(video);
      }
    }

    // Handle iframe videos (YouTube/Vimeo)
    // These are controlled by their URL parameters set in Liquid
  });
});
